/* eslint-disable import/prefer-default-export */
import {
  configureStore,
} from '@reduxjs/toolkit';
// Or from '@reduxjs/toolkit/query/react'
import {
  setupListeners,
} from '@reduxjs/toolkit/query';
import {
  merchantApi,
} from './services/merchant';
import {
  userManagementApi,
} from './services/userManagement';
import {
  paymentTransactionApi,
} from './services/paymentTransaction';
import merchantReducer from './features/merchant/merchantSlice';

export const store = configureStore({
  reducer: {
    // Add the generated reducer as a specific top-level slice

    [merchantApi.reducerPath]: merchantApi.reducer,
    [userManagementApi.reducerPath]: userManagementApi.reducer,
    [paymentTransactionApi.reducerPath]: paymentTransactionApi.reducer,
    merchant: merchantReducer,
  },
  // Adding the api middleware enables caching, invalidation, polling,
  // and other useful features of `rtk-query`.
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(merchantApi.middleware)
    .concat(userManagementApi.middleware).concat(paymentTransactionApi.middleware),
});

// optional, but required for refetchOnFocus/refetchOnReconnect behaviors
// see `setupListeners` docs - takes an optional callback as the 2nd arg for customization
setupListeners(store.dispatch);
